<div class="profile-container">
  <div class="tabs">
    <div class="tab" [class.active]="activeTab === 'profile'" (click)="setActiveTab('profile')">
      <i class="fas fa-user"></i> Profil Bilgileri
    </div>
    <div class="tab" [class.active]="activeTab === 'password'" (click)="setActiveTab('password')">
      <i class="fas fa-key"></i> Şifre Değiştir
    </div>
  </div>

  <div class="tab-content">
    <div *ngIf="activeTab === 'profile'" class="profile-info">
      <div class="user-avatar">{{ user?.username?.charAt(0) }}</div>
      <div class="info-group">
        <label>Kullanıcı Adı:</label>
        <input type="text" [(ngModel)]="user.username" disabled>
      </div>
      <div class="info-group">
        <label>E-posta:</label>
        <input type="email" [(ngModel)]="user.email">
      </div>
      <div *ngIf="profileMessage" class="message" [class.success]="profileMessage.type === 'success'" [class.error]="profileMessage.type === 'error'">
        {{ profileMessage.text }}
      </div>
      <button class="save-btn" (click)="updateProfile()">Kaydet</button>
    </div>

    <div *ngIf="activeTab === 'password'" class="password-change">
      <div class="info-group">
        <label>Mevcut Şifre:</label>
        <input type="password" [(ngModel)]="passwordData.currentPassword">
      </div>
      <div class="info-group">
        <label>Yeni Şifre:</label>
        <input type="password" [(ngModel)]="passwordData.newPassword">
      </div>
      <div class="info-group">
        <label>Yeni Şifre (Tekrar):</label>
        <input type="password" [(ngModel)]="passwordData.confirmPassword">
      </div>
      <div *ngIf="passwordMessage" class="message" [class.success]="passwordMessage.type === 'success'" [class.error]="passwordMessage.type === 'error'">
        {{ passwordMessage.text }}
      </div>
      <button class="save-btn" (click)="changePassword()">Şifreyi Değiştir</button>
    </div>
  </div>
</div> 